import { render, staticRenderFns } from "./support-modal-success.vue?vue&type=template&id=eda04504&scoped=true&"
import script from "./support-modal-success.vue?vue&type=script&lang=ts&"
export * from "./support-modal-success.vue?vue&type=script&lang=ts&"
import style0 from "./support-modal-success.vue?vue&type=style&index=0&id=eda04504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda04504",
  null
  
)

export default component.exports